import {
  ClockCircleOutlined,
  MailTwoTone, PhoneTwoTone, ThunderboltTwoTone,
} from '@ant-design/icons';
import { Flex } from 'antd';
import React from 'react';

export const getWorkflowItemIcon = (item, {
  waitIcon,
} = { waitIcon: true }) => {
  const getWaitTitle = (action) => {
    if (action.code === 'wait_minutes') {
      const minutes = action.summary_definition?.find((item) => item.name === 'wait_minutes').initial;
      if (minutes >= 60) {
        const hours = Math.round(minutes / 60);
        return `${hours}hr`;
      }
      return `${minutes}m`;
    }
    if (action.code === 'wait_business_days') {
      const days = action.summary_definition?.find((item) => item.name === 'wait_days').initial;
      return `${days}d`;
    }
    return 'Wait Action';
  };

  const actionCode = item.code || item;
  switch (actionCode) {
  case 'email':
    return wrap(<MailTwoTone className="text-xs" />, {
      backgroundColor: '#E6F7FF',
      borderColor: '#1890FF',
    });
  case 'wait':
  case 'wait_minutes':
  case 'wait_business_days':
    return waitIcon ?
      wrap(<ClockCircleOutlined className="text-xs" />, {
        borderColor: '#666B71',
        color: '#666B71',
      }) :
      wrap(getWaitTitle(item), {
        borderColor: '#666B71',
        color: '#666B71',
        fontSize: '12px',
      });
  case 'call':
    return wrap(<PhoneTwoTone twoToneColor="orange" />, {
      backgroundColor: '#FFF1E6',
      borderColor: '#FFA940',
    });
  case 'trigger':
    return wrap(<ThunderboltTwoTone twoToneColor="orange" />, {
      backgroundColor: '#FFF1E6',
      borderColor: '#FFA940',
    });
  default:
    return null;
  }

  function wrap(icon, style) {
    return (
      <Flex
        align="center"
        justify="center"
        className="w-[22px] h-[22px]"
        style={{
          borderWidth: '0.5px',
          borderStyle: 'solid',
          borderRadius: '5px',
          ...style,
        }}
      >
        {icon}
      </Flex>
    );
  }
};
